window.removeModalForm = function() {
  document.getElementById('js-modal-wrapper').innerHTML = '';
}
